import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UserRoleService } from '../../../services/user-role.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
})
export class SideMenuComponent implements OnInit {
  menuItems: any[] = [];
  loadingRole = true;
  openSubmenu: string | null = null;
  allMenuItems = [
  {
    icon: '📊',
    label: 'Dashboard',
    route: '/dashboard',
    roles: ['superadmin', 'admin', 'csr'],
  },
  {
    icon: '💳',
    label: 'Cards',
    route: '/cards',
    roles: ['superadmin', 'admin', 'csr'],
  },
  {
    icon: '📋',
    label: 'Listing',
    route: '/listing',
    roles: ['superadmin', 'admin', 'csr'],
  },
  {
    icon: '👤',
    label: 'Users',
    route: '/users',
    roles: ['superadmin', 'admin'],
  },
  {
    icon: '🏛️',
    label: 'Agencies',
    route: '/agencies',
    roles: ['superadmin', 'admin', 'csr'],
  },
  {
    icon: '🏢',
    label: 'Corporates',
    route: '/corporates',
    roles: ['superadmin', 'admin', 'csr'],
  },
  {
    icon: '👥',
    label: 'Administrators',
    route: '/admins',
    roles: ['superadmin', 'admin'],
  },
  {
    icon: '📈',
    label: 'Reports',
    roles: ['superadmin', 'admin'],
    submenus: [
      {
        icon: '📈',
        label: 'Analytics',
        route: '/analytics',
        roles: ['superadmin', 'admin'],
      },
      {
        icon: '📏',
        label: 'Metrics',
        route: '/metrics',
        roles: ['superadmin', 'admin'],
      },
    ],
  },
  {
    icon: '⚙️',
    label: 'Settings',
    roles: ['superadmin', 'admin', 'csr'],
    submenus: [
      {
        icon: '🎁',
        label: 'Wishlist',
        route: '/wishlist',
        roles: ['superadmin', 'admin', 'csr'],
      },
      {
        icon: '🏷️',
        label: 'Categories',
        route: '/categories',
        roles: ['superadmin', 'admin', 'csr'],
      },
      {
        icon: '📧',
        label: 'Email Templates',
        route: '/email',
        roles: ['superadmin', 'admin', 'csr'],
      },

       {
        icon: '📧',
        label: 'Emails',
        route: '/emails',
        roles: ['superadmin', 'admin', 'csr'],
      },
    ],
  },
];


  constructor(
    public authService: AuthService,
    private userRoleService: UserRoleService,
    private router: Router
  ) {}

  async ngOnInit() {
    const user = this.authService.currentUser;
    if (!user.role || !['superadmin', 'admin', 'csr'].includes(user.role)) {
      this.router.navigate(['/unauthorized']);
      return;
    }
    this.menuItems = this.allMenuItems.filter((item) =>
      item.roles.includes(user.role)
    );
    this.loadingRole = false;
  }

  toggleSubmenu(itemLabel: string): void {
    this.openSubmenu = this.openSubmenu === itemLabel ? null : itemLabel;
  }
  async signOut(): Promise<void> {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  }
}